<template>
  <div>
    <p class="OrderTop">
      <span><router-link to="/personal"><img src="../../assets/images/users/Return.png"></router-link></span>
      <span>購入履歴</span>
      <span></span>
    </p>
    <div class="order_nav">
      <router-link to="/personal/order/all" active-class="selected"><span>注文履歴</span></router-link>
      <router-link to="/personal/order/unpaid" active-class="selected"><span>未払い</span></router-link>
      <router-link to="/personal/order/paid" active-class="selected"><span>支払い済み</span></router-link>
      <router-link to="/personal/order/finish" active-class="selected"><span>取引完了</span></router-link>
    </div>
    <div class="order_main">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
  export default{
    name: "",
    data(){
      return {
        msg: 'hello vue',
      }
    },
    created(){

    },
    methods: {
      back(){
        this.$router.go(-1)
      },
    },
    components: {}
  }
</script>
<style lang="scss">
  @import "../../../static/pubilc";

  @media screen and(min-width: $min-screen) and(max-width: $P749screen) {
    .OrderTop{
      height: 50px;
      background-color: $TitColor;
      display: flex;
      justify-content: space-between;
      line-height: 50px;
      color: $whiteColor;
      position: fixed;
      top:0;
      left:0;
      right:0;
      span:nth-child(1),
      span:nth-child(3) {
        width: 50px;
        display: inline-block;
        height: 50px;
        img {
          margin-top: 10px;
          margin-left: 10px;
        }
      }
    }
    .order_nav {
      margin-top: 50px;
      height: 40px;
      width: 100%;
      background-color: #dcdcdc;
      line-height: 40px;
      font-size: 14/$default-w+rem;
      span {
        text-align: center;
        float: left;
        display: inline-block;
        width: 25%;
        color: black;
      }
      .selected > span {
        color: $navcolor;
      }
    }
    .order_main {
      width: 100%;
      /*height: 400px;*/
    }
  }

  @media screen and(min-width: $P750screen) {
    .OrderTop{
      display: none;
    }
    .order_nav {
      height: 50px;
      width: 100%;
      background-color: #dcdcdc;
      line-height: 50px;
      span {
        text-align: center;
        float: left;
        display: inline-block;
        width: 25%;
        color: black;
      }
      .selected > span {
        color: $navcolor;
      }
    }
    .order_main {
      width: 100%;
      height: 750px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/personal/order.vue